import styles from "@/styles/modules/components/featured.module.scss";
import { FeaturedComponent } from "@/types/modules";
import Image from "next/image";
import Link from "next/link";

interface FeaturedProps {
  featured: FeaturedComponent;
}

export default function Featured({ featured }: FeaturedProps) {
  if (!featured.title && !featured.custom) return null;

  return (
    <section
      className={styles.featured}
      style={{
        backgroundColor: featured.backgroundColor || "transparent",
      }}
    >
      <div className={styles.featuredContainer}>
        {featured.title && <h2 data-aos="fadeIn">{featured.title}</h2>}
        <div className={styles.content}>
          {featured.custom &&
            featured.custom.slice(0, 3).map((custom, i) => (
              <article key={i} className={styles.item}>
                {(custom.link && custom.image) ? (
                  <Link
                    href={custom.link.url || ""}
                    target={custom.link.target}
                    data-aos="fadeIn"
                    data-aos-delay={100 * i + 200}
                  >
                    <Image
                      alt={custom.image.node.altText || "Imperial Riding School"}
                      src={custom.image.node.link}
                      width={custom.image.node.mediaDetails.width}
                      height={custom.image.node.mediaDetails.height}
                    />
                  </Link>
                ) : (custom.image && (
                  <Image
                    alt={custom.image.node.altText || "Imperial Riding School"}
                    src={custom.image.node.link}
                    width={custom.image.node.mediaDetails.width}
                    height={custom.image.node.mediaDetails.height}
                    data-aos="fadeIn"
                    data-aos-delay={100 * i + 200}
                  />
                ))}
                {custom.link ? (
                  <>
                    <h3 data-aos="fadeIn"
                      data-aos-delay={100 * i + 200}>{custom.title}</h3>
                    <Link href={custom.link.url || ""} target={custom.link.target} data-aos="fadeIn"
                      data-aos-delay={100 * i + 200}>{custom.link.title}</Link>
                  </>
                ) : (
                  <div className={styles.description} data-aos="fadeIn"
                    data-aos-delay={100 * i + 200}>
                    {custom.title}
                  </div>
                )}
              </article>
            ))}
        </div>
      </div>
    </section>
  );
}
